export const localization = {
    "snackbar": {
      "fullName": "Nombre completo",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "role-userType": "Detalle"
    },
    "main": {
      "title": "Localización",
      "subtitle": "Debe aplicar filtros para poder visualizar la localización de los usuarios"
    }
  }